module.exports = __webpack_public_path__ + "content/419d5595fe54e40d60dbf46693594cec.png";